module.exports = __webpack_public_path__ + "img/dashboard.dad8a354.png";